import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './index.css'
import '@/lib/i18n'
import App from './App.tsx'

type ThemeName = "light" | "dark"

const THEME_STORAGE_KEY = "theme"
const DARK_MEDIA_QUERY = "(prefers-color-scheme: dark)"

const resolveInitialTheme = (): ThemeName => {
  if (typeof window === "undefined") return "light"

  try {
    const storedTheme = window.localStorage.getItem(THEME_STORAGE_KEY)
    if (storedTheme === "light" || storedTheme === "dark") {
      return storedTheme
    }
  } catch {
    // Ignore storage access errors (e.g., Safari private browsing)
  }

  return window.matchMedia && window.matchMedia(DARK_MEDIA_QUERY).matches
    ? "dark"
    : "light"
}

const primeDocumentTheme = () => {
  if (typeof document === "undefined") return
  const root = document.documentElement
  const theme = resolveInitialTheme()
  root.dataset.theme = theme
  root.classList.toggle("dark", theme === "dark")
  root.style.setProperty("color-scheme", theme)
}

primeDocumentTheme()

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
